<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    to="/newjob"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="showmap = !showmap"
                    tile
                    small
                    v-if="showmap"
                    >
                        Hide Map
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="showmap = !showmap"
                    tile
                    small
                    v-else
                    >
                        Jobs Map
                </v-btn>
                <downloadexcel
                    class            = "btn"
                    :fetch           = "fetchData"
                    :fields          = "json_fields"
                    :before-generate = "startDownload"
                    :before-finish   = "finishDownload"
                    name="export.xls"
                    v-if="total > 0"
                    >
                    <v-btn
                        color="#ffffff"
                        class="primary--text"
                        tile
                        small
                        :loading="downloadLoading"
                        >
                            Export
                    </v-btn>
                </downloadexcel>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="jobs-count" >
                     {{ total + ' Jobs Found.' }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card>
        <v-card
            flat
            loader-height="10"
            tile
            min-width="100%"
            v-if="showmap"
        >
            <v-row
                align="center"
                justify="center"
                class="pa-0 ma-0"
            >
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="pa-0 ma-0"
                >
                <mapbox
                    access-token="pk.eyJ1IjoiYmlnY2l0eSIsImEiOiJjazhpb2c0cGgwNnh0M21ud2s3YzY4MGpjIn0.0AYL_R9U7wU8WQck6doT-w"
                    :map-options="{
                        style: 'mapbox://styles/mapbox/streets-v9',
                        center: [-86.327204, 32.3524829],
                        zoom: 10,
                    }"
                    @map-load="loaded"
                    @map-click:points="clicked"
                    @map-mouseenter:points="mouseEntered"
                    @map-mouseleave:points="mouseLeft"
                    :key="mapKey"
                />
                </v-col>
            </v-row>
        </v-card>
        <v-card
            flat
            loader-height="10"
            tile
            min-width="100%"
        >
            <v-list two-line tile flat class="py-0 hover-list">
                <template v-for="(jobs, i) in groups">
                    <v-subheader class="jg-header" :key="`jgtitle-${i}`">{{ i }}</v-subheader>
                    <v-list-item-group :key="`jg-${i}`">
                        <template v-for="(job, index) in jobs">
                            <v-list-item
                            :key="`job-${index}`"
                            :value="job.id"                 
                            >
                                <template>
                                    <v-list-item-content @click.stop="openJob(job.id)">
                                        <v-list-item-title>{{ job.customer.street_address+ ', ' + job.customer.city + ', ' + job.customer.state + ' ' + job.customer.zip }}</v-list-item-title>
                                        <v-list-item-subtitle v-html="job.customer.title"></v-list-item-subtitle>
                                        <v-list-item-subtitle>{{ job.job_time | moment('MMMM Do YYYY, h:mm a') }}</v-list-item-subtitle>
                                        <div>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            :color="getColor(job.status)"
                                            text-color="white"
                                            small
                                            label
                                            >
                                            {{ job.status | capitalize }}
                                            </v-chip>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            color="purple"
                                            text-color="white"
                                            small
                                            label
                                            v-if="job.customer.cover_check == 'yes'"
                                            >
                                            Cover Check
                                            </v-chip>
                                        </div>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-list-item-icon class="ma-0 mb-1">
                                            <v-btn small tile class="mr-1" elevation="0" color="#0298c6" dark @click.stop="googleLink(job.customer)">
                                                <v-icon dark>mdi-map-marker</v-icon>
                                            </v-btn>

                                            <v-btn small tile class="mr-1" color="#003a6f" elevation="0" dark @click.stop="dial(job.customer.phone)">
                                                <v-icon dark>mdi-phone</v-icon>
                                            </v-btn>
                                        </v-list-item-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                            <v-divider
                            :key="`dv-${index}`"
                            ></v-divider>
                        </template>
                    </v-list-item-group>
                </template>  
                <v-list-item v-if="pagination.total > 1">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
        <FilterJobs :show="drawer" :filter="filter" :routekey="routeKey" @update-status="updateStatus" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @update-daterange="updateDaterange" @update-cleaner="updateCleaner" @submit-search="submitSearch"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterJobs from '../components/FilterJobs.vue'
import Mapbox from 'mapbox-gl-vue'
import PopupContent from '../components/PopupContent.vue'
import downloadexcel from "vue-json-excel"

export default {
    data() {
        return {
            showmap: false,
            drawer: false,
            loading: true,
            downloadLoading: false,
            groups: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                keyword: "",
                status: ["active", "completed"],
                daterange: "",
                cleaner: []
            },
            total: 0,
            markers: [],
            mapKey: 0,
            json_fields: {
                'Date': 'date',
                'Customer Name': 'customer_name',
                'Address': 'address',
                'Email' : 'email',
                'Chemicals': 'chemicals',
                'Pricing' : 'pricing',
                'Job Comments': 'comment',
                'Customer Comments': 'customer_comment'
            },
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        this.getJobs()
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else if(this.filter.status != 'all' && this.filter.cleaner != []) {
                //return this.filter.status.charAt(0).toUpperCase() + this.filter.status.slice(1) + ' Jobs'
                return this.pageTitle
            } else {
                return this.pageTitle
            }
        },
    },
    components: {
        FilterJobs,
        Mapbox,
        downloadexcel,
    },
    methods: {
        getJobs() {
            this.loading = true
            this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.groups = response.data.groups
                this.markers = response.data.markers
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.all = response.data.all
                this.mapKey += 1
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        openJob(id) {
            this.$router.push({ path: '/job/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        googleLink (customer) {
            let link = 'https://www.google.com/maps?saddr=Current+Location&daddr=' + encodeURI(customer.street_address+ ', ' + customer.city + ', ' + customer.state + ' ' + customer.zip)
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updateStatus(val) {
            this.filter.status = val
            this.getJobs()
        },
        updateCleaner(val) {
            this.filter.cleaner = val
            this.getJobs()
        },
        updateDaterange(val) {
            this.filter.daterange = val
        },
        submitSearch() {
            this.getJobs()
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        loaded(map) {
            //map.addImage('cat', 'http://admin.mrpoolal.com/img/flag-icon-png-19.jpg');
            map.addLayer({
                id: 'points',
                type: 'symbol',
                source: {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: this.markers,
                    },
                },
                layout: {
                    'text-field': ['get', 'title'],
                    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-radial-offset': 0.5,
                    'text-justify': 'auto',
                    'icon-image': 'circle-15'
                },
            })
        },
        clicked(map, e) {
            if (e.features) {
                const coordinates = e.features[0].geometry.coordinates.slice()

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
                }

                new mapboxgl.Popup()
                .setLngLat({ lng: coordinates[0], lat: coordinates[1] })
                .setHTML('<div id="vue-popup-content"></div>')
                .addTo(map)

                new PopupContent({
                propsData: { feature: e.features[0] },
                }).$mount('#vue-popup-content')
            }
        },
        mouseEntered(map) {
            map.getCanvas().style.cursor = 'pointer'
        },
        mouseLeft(map) {
            map.getCanvas().style.cursor = ''
        },
        async fetchData(){
            const response = await axios.get('admin/jobs/export', {
                params: this.filter
            });
            console.log(response);
            return response.data;
        },
        startDownload(){
            this.downloadLoading = true
        },
        finishDownload(){
            this.downloadLoading = false
        }
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff
.fullscreen
    background: #fff
    height: 100%
.w-100
    width: 100%
    .v-btn 
        width: 100%
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.v-chip 
    border-radius: 0!important
.jobs-count
    font-size: 14px
.jg-header
    background: #1976d2
    color: #fff
    font-size: 18px
</style>